module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-input v-text-field"
  }, [_c('div', {
    class: _vm.classes,
    staticStyle: {
      "position": "relative",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "input-group__input",
    style: (("height: " + _vm.heightEditor + ";"))
  }, [_c('label', {
    class: _vm.classesLabel,
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "top": "-16px"
    }
  }, [_vm._v(_vm._s(_vm.label) + " ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "htmlValueEditor"
    }
  })]), _vm._v(" "), (_vm.hint) ? _c('div', {
    staticClass: "input-group__details"
  }, [_c('div', {
    staticClass: "input-group__messages input-group__hint v-messages theme--light v-messages__wrapper v-messages__message"
  }, [_vm._v(_vm._s(_vm.hint))])]) : _vm._e()]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.showPopup
    }
  }, [_c('i', {
    staticClass: "v-icon theme--light icon-macro",
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "display": "inline-block",
      "background-size": "contain"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eaa8f8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/MacroField.vue
// module id = 835
// module chunks = 1